<template>
  <div class="">
    <div class="label-standard">
      <RequiredAsterisk v-if="required"></RequiredAsterisk>
      {{ label }}
    </div>

    <div class="form-line">
      <select class="select-standard"
        v-bind:value="getValue()"
        v-on:change="updateValue({
          objectId: objectId,
          index   : index,
          key     : propertyKey, 
          value   : $event.target.value
        })">
        <option value="-1" disabled="">Select an option...</option>
        <template v-for="(lender, index) in getLenders()">
          <option :value="lender">{{ lender }}</option>
        </template>
        <option value="Other">Other</option>
      </select>
    </div>
  </div>
</template>

<script>

  import RequiredAsterisk from '@/shared/components/form/RequiredAsterisk'

  export default {

    components : {
      RequiredAsterisk
    },
    
    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type    : Number,
        required: false,
      },

      label : {
        type    : String,
        required: false,
        default : 'Lender'
      },

      value : {
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      disabled : {
        type : Boolean,
        required : false,
        default : false
      },

      required : {
        type    : Boolean,
        required: false,
        default : false
      }
    },

    methods : {
      getValue() {
        if(this.value == null) {
          return -1
        }

        else if(this.isOtherLander(this.value)) {
         return 'Other'
        }

        else {
          return this.value
        }
      }
    }
  }
</script>